import gql from "graphql-tag";

export const ADD_COMMENT = gql`
  mutation ($input: commentInput) {
    addComment(input: $input) {
      _id
      content
      created_at
      created_by {
        _id
        full_name
        email
        avatar
      }
    }
  }
`;
